const defaultState = [23, 'alpha', 9]

export default (state=defaultState, action) =>
  state
